import { render, staticRenderFns } from "./ConfiguredOptionsListChart.vue?vue&type=template&id=8396d8c2&scoped=true&"
import script from "./ConfiguredOptionsListChart.vue?vue&type=script&lang=js&"
export * from "./ConfiguredOptionsListChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8396d8c2",
  null
  
)

export default component.exports